import Cart from "./cart"
import CartInput from "./cart-input"
import { magicDisable } from "./helpers"
import { cartJson, themeName } from "./liquidInit"
import ProductInput from "./product-input"

const plusMinusHandler = (event) => {
  if (event.target.disabled === true) {
    return
  }

  if (event.target.matches(ProductInput.minusButtonSelector)) {
    ProductInput.minus(event.target.parentNode)
  }
  if (event.target.matches(ProductInput.plusButtonSelector)) {
    ProductInput.plus(event.target.parentNode)
  }

  if (event.target.matches(CartInput.minusButtonSelector)) {
    CartInput.minus(event.target.parentNode)
  }
  if (event.target.matches(CartInput.plusButtonSelector)) {
    CartInput.plus(event.target.parentNode)
  }
}

const typeInputHandler = (event) => {
  if (
    !event.target.matches(ProductInput.visibleInputSelector) &&
    !event.target.matches(CartInput.visibleInputSelector)
  )
    return

  if (event.target.matches(ProductInput.visibleInputSelector)) {
    ProductInput.type(event.target.parentNode)
  }

  if (event.target.matches(CartInput.visibleInputSelector)) {
    CartInput.type(event.target.parentNode)
  }
}

const checkoutButtonHandler = (event) => {
  if (!event.target.matches(Cart.checkoutSelectors)) {
    return
  }

  if (event.target.disabled === true) {
    return
  }

  event.preventDefault()
  event.stopPropagation()

  if (event.target.matches(Cart.checkoutSelectors)) {
    Cart.checkout(event)
  }
}

let latestUpdate = ""

const localStorageHandler = (event) => {
  if (event.key === "cart") {
    console.warn("[LocalStorage Event]")
    const currentCartString = JSON.stringify(cartJson)
    const updatedCartString = event.newValue
    const newCart = JSON.parse(updatedCartString)
    if (
      updatedCartString !== currentCartString &&
      updatedCartString !== latestUpdate
    ) {
      console.warn("[Local Storage Change Update Containers]")
      latestUpdate = updatedCartString
      ProductInput.updateAfterLocalStorageChange(newCart)
      CartInput.updateAfterLocalStorageChange(newCart)
    } else {
      console.warn("[Containers are in Sync]")
    }
  }
}

const onAjaxStartHandler = (event) => {
  console.warn("[Ajax Start]", event)
  Cart.disableButtons()
}

const onAjaxEndHandler = (event) => {
  console.warn("[Ajax End]", event)
  Cart.enableButtons()
}

let firstTimeUrl = document.URL

export default function initEventListeners() {
  window.addEventListener("storage", localStorageHandler, false)
  document.addEventListener('change', () =>{
    let currentPageUrl = document.URL;
    const url = new URL(currentPageUrl);
    const isVariantUrl = url.searchParams.get("variant");
    currentPageUrl = isVariantUrl ? currentPageUrl :isVariantUrl;
      if(currentPageUrl && firstTimeUrl !== currentPageUrl) {
        firstTimeUrl = currentPageUrl;
        console.log(`variant_id: ${isVariantUrl}`)
      }
    })
  document.addEventListener(
    "touchstart",
    (event) => {
      if (
        !event.target.matches(ProductInput.minusButtonSelector) &&
        !event.target.matches(ProductInput.plusButtonSelector) &&
        !event.target.matches(CartInput.minusButtonSelector) &&
        !event.target.matches(CartInput.plusButtonSelector)
      ) {
        return
      }

      event.preventDefault()
      event.stopPropagation()

      plusMinusHandler(event)
    },
    {
      passive: false,
    }
  )
  document.addEventListener(
    "touchend",
    (event) => {
      // If the clicked element doesn't have the right selector, bail
      if (
        !event.target.matches(ProductInput.minusButtonSelector) &&
        !event.target.matches(ProductInput.plusButtonSelector) &&
        !event.target.matches(CartInput.minusButtonSelector) &&
        !event.target.matches(CartInput.plusButtonSelector)
      ) {
        return
      }

      event.preventDefault()
      event.stopPropagation()
    },
    {
      passive: false,
    }
  )
  document.addEventListener(
    "mousedown",
    (event) => {
      // If the clicked element doesn't have the right selector, bail
      if (
        event.target instanceof HTMLDocument ||
        Object.prototype.toString.call(event.target) ===
          "[object HTMLDocument]" ||
        (!event.target.matches(ProductInput.minusButtonSelector) &&
          !event.target.matches(ProductInput.plusButtonSelector) &&
          !event.target.matches(CartInput.minusButtonSelector) &&
          !event.target.matches(CartInput.plusButtonSelector))
      ) {
        return
      }

      event.preventDefault()
      event.stopPropagation()

      plusMinusHandler(event)
    },
    {
      passive: false,
    }
  )
  document.addEventListener("keypress", (event) => {
    if (
      !event.target.matches(ProductInput.visibleInputSelector) &&
      !event.target.matches(CartInput.visibleInputSelector)
    ) {
      return
    }

    if (
      (event.which !== 46 &&
        event.which !== 8 &&
        event.which !== 0 &&
        event.which < 48) ||
      event.which > 57
    ) {
      event.preventDefault()
    }
  })
  document.addEventListener("click", checkoutButtonHandler, false)
  if (themeName === "Supply") {
    document.addEventListener(
      "click",
      (event) => {
        if (
          event.target.matches(ProductInput.addToCartSelector) &&
          !event.target.parentNode.disabled
        ) {
          event.preventDefault()
          event.stopPropagation()
          magicDisable(
            event.target.closest(`button${ProductInput.addToCartSelector}`)
          )
          event.target.closest(ProductInput.addToCartFormSelector).submit()
        }
      },
      false
    )
  }
  document.addEventListener("change", typeInputHandler, false)
  document.addEventListener("onAjaxStart", onAjaxStartHandler, false)
  document.addEventListener("onAjaxEnd", onAjaxEndHandler, false)
}
